export const ACTION_SET_EDITOR_WORDS = 'SET_EDITOR_WORDS';
export const ACTION_SET_DELETE_EDITOR_WORD='SET_EDITOR_DELETE_WORD'

export const setEditorWords = (words) => {
    return {
        type: ACTION_SET_EDITOR_WORDS,
        payload: words
    }
}


 export const setDeleteEditorWord = (idx) => {
    return {
        type:ACTION_SET_DELETE_EDITOR_WORD,
        payload:idx
    }
} 